import FrontContentWrapper from './FrontContentWrapper';

export default FrontContentWrapper;
